import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { useProfile } from "@/context/ProfileContext";
import { errorMessage } from "@/lib/api";
import { formatCount } from "@/lib/format";
import { toast } from "sonner";

export const LikeButton = ({ track, size = "sm", kind = "tracks" }) => {
  const { request } = useProfile();
  const [state, setState] = useState({ liked: track.liked_by_me, count: track.like_count });
  const [busy, setBusy] = useState(false);
  useEffect(() => setState({ liked: track.liked_by_me, count: track.like_count }), [track.id, track.liked_by_me, track.like_count]);

  const toggle = async (e) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    const prev = state;
    setState({ liked: !prev.liked, count: prev.count + (prev.liked ? -1 : 1) });
    try {
      const r = await request(prev.liked ? "delete" : "post", `/${kind}/${track.id}/like`);
      setState({ liked: r.liked, count: r.like_count });
    } catch (err) { setState(prev); toast.error(errorMessage(err)); } finally { setBusy(false); }
  };

  const big = size === "lg";
  return (
    <button data-testid={`like-button-${track.id}`} onClick={toggle} aria-pressed={state.liked} aria-label="Like"
      className={`inline-flex items-center gap-1.5 rounded-full transition-[color,transform] duration-200 active:scale-90 ${big ? "px-4 py-2 border border-white/15 text-sm" : "text-xs"} ${state.liked ? "text-nw-red" : "text-slate-400 hover:text-white"}`}>
      <Heart className={big ? "h-5 w-5" : "h-4 w-4"} fill={state.liked ? "currentColor" : "none"} />
      <span data-testid={`like-count-${track.id}`}>{formatCount(state.count)}</span>
    </button>
  );
};
